/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {useEffect} from 'react'
import {Redirect, Route, Switch} from 'react-router-dom'
import {CreateWrapper} from './containers/CreateVendor'
import {ListWraaper} from './containers/List'

export function VendorPage() {
  useEffect(() => {}, [])

  return (
    <div>
      <Switch>
        <Route path='/vendor/list' exact={true} component={ListWraaper} />
        <Route
          path='/vendor/create'
          exact={true}
          component={CreateWrapper}
        />
        <Redirect from='/vendor' exact={true} to='/vendor/list' />
        <Redirect to='/vendor/list' />
      </Switch>
    </div>
  )
}
